/* prettier-ignore */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { RestService } from 'src/app/services/rest.service';
import dayjs, { Dayjs } from 'dayjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })

export class RegisterStandaloneService {
    private rest = inject(RestService);
    private http = inject(HttpClient);
    private translate = inject(TranslateService)

    public tokenRegister: any;
    public idRegister: any;
    public clientId: any;
    public channelId: any;
    
    private dateRange = signal({ from: dayjs().format('YYYY-MM-DD'), to: dayjs().format('YYYY-MM-DD')});
    private travelerType = signal(null);
    private categories = signal([]);
    public registerBeforeQuestion = signal(null);
    private registerBeforeAnswer = signal(null);
    public registerAfterQuestion = signal(null);
    private registerAfterAnswer = signal(null);
    public surveyQuestion = signal(null);

    private name = signal(null);
    private email = signal(null);

    public isTravelerTypeError = computed(() => this.travelerType() === null);
    public isInterestTypeError = computed(() => this.categories().length === 0);
    public showRegisterBeforeError = signal(false);
    public showRegisterAfterError = signal(false);

    getRegisterDataStandaloneByToken(token){
        this.tokenRegister = token;
        return this.http.get(`${this.rest.apiUrlBase}/api/get-channelinfo/${token}`);
    }

    getRegisterDataStandaloneById(id){
        this.idRegister = id;
        return this.http.get(`${this.rest.apiUrlBase}/api/get-onlyregisterinfo/${this.rest.subDomain}/${id}`);
    }

    sendRegisterData(){
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const params = this.idRegister || this.tokenRegister;
        const postRegister = this.generateStructure();
        return this.http.post(`${this.rest.apiUrlBase}/api/post-register/${params}`, postRegister, {headers})
    }

    setCalendarData(dateRange){
        if (!dateRange?.startDate || !dateRange.endDate)
            return;

        this.dateRange.set({
            from: dateRange.startDate,
            to: dateRange.endDate
        })
    }

    setTravelerType(id){
        if (!id)
            return;

        this.travelerType.set(id);
    }

    setCategories(data){
        if (!data || data?.length === 0)
            return;

        this.categories.set(data);
    }

    setRegisterBeforeAnswer(registerAnswer){
        if (!registerAnswer || registerAnswer?.length === 0)
            return;

        this.registerBeforeAnswer.update(prev => registerAnswer);
    }

    resetRegisterBefore(){
        this?.showRegisterBeforeError?.update(prev => false);
        this.registerBeforeAnswer.update(prev => null);
    }

    setRegisterAfterAnswer(registerAnswer){
        if (!registerAnswer || registerAnswer?.length === 0)
            return;

        this.registerAfterAnswer.update(prev => registerAnswer);
    }

    resetRegisterAfter(){
        this?.showRegisterAfterError?.update(prev => false);
        this.registerAfterAnswer.update(prev => null);
    }

    getArrayIndexErrors(registerAnswer){
        return registerAnswer?.map(data => data.required && (!data.answer || data.answer?.length === 0 || data.answer === ''));
    }

    setUserData(user){
        this.name = user.name
        this.email = user.email;
    }

    generateStructure(){
        return {
            register: {
                calendar: this.dateRange(),
                travelerType: this.travelerType(),
                selectedCategories: this.categories(),
                clientID: this.clientId,
                lang: this.translate.currentLang,
                registerBefore: this.registerBeforeAnswer(),
                registerAfter: this.registerAfterAnswer(),
                userData: {
                    email: this.email,
                    name: this.name
                }
            }
        }
    }

    isErrorFromRegisterBefore(){
        if (!this.registerBeforeQuestion()?.[this.translate.currentLang]?.some(answer => answer.required))
            return false;

        if (this.registerBeforeAnswer())
            return this.registerBeforeAnswer()?.filter(answer => answer.required)?.some(data => !data.answer || data.answer?.length === 0 || data.answer === '');

        return true;
    }

    isErrorFromRegisterAfter(){
        if (!this.registerAfterQuestion()?.[this.translate.currentLang]?.some(answer => answer.required))
            return false;

        if (this.registerAfterAnswer())
            return this.registerAfterAnswer()?.filter(answer => answer.required)?.some(data => !data.answer || data.answer?.length === 0 || data.answer === '');

        return true;
    }
}